import React from "react";

/*
 * Icon buttons per DESIGN.md §4 + the mini-player/list-row controls in the showcase.
 * square:        74×74, radius 16, 1px #D2D6DC border (media-type / large actions)
 * solid:         circular Royal Blue (play / resume)
 * circleOutline: circular, #D2D6DC border, blue glyph (secondary play)
 * bareDark:      circular transparent on navy (transport controls)
 * All ≥44px targets. `dark` switches the focus ring to the Sky Blue variant.
 */

const BASE =
  "inline-flex items-center justify-center flex-shrink-0 font-sans cursor-pointer transition-all duration-150 ease-out focus-visible:outline-none disabled:cursor-not-allowed";

const VARIANTS = {
  square:
    "bg-transparent text-black border border-ic-borderGray rounded-2xl " +
    "hover:bg-black/5 hover:border-[#B4B4B4] active:bg-black/10 active:border-[#888888] " +
    "focus-visible:border-ic-blue focus-visible:shadow-ic-focus-soft",
  solid:
    "bg-ic-blue text-ic-offwhite border-0 rounded-full " +
    "hover:bg-ic-blueHover hover:shadow-ic-cta-hover active:bg-ic-blueActive",
  circleOutline:
    "bg-transparent text-ic-blue border border-ic-borderGray rounded-full " +
    "hover:bg-black/5 hover:border-[#B4B4B4] active:bg-black/10 " +
    "focus-visible:border-ic-blue focus-visible:shadow-ic-focus-soft",
  bareDark:
    "bg-transparent text-ic-lightGray border-0 rounded-full " +
    "hover:bg-white/10 hover:text-white",
};

const IconButton = React.forwardRef(function IconButton(
  {
    variant = "solid",
    size = 44,
    dark = false,
    label,
    className = "",
    style,
    children,
    ...rest
  },
  ref
) {
  const focusRing =
    variant === "solid" || variant === "bareDark"
      ? dark
        ? "focus-visible:shadow-ic-focus-dark"
        : "focus-visible:shadow-ic-focus"
      : "";
  return (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      className={`${BASE} ${VARIANTS[variant] || VARIANTS.solid} ${focusRing} ${className}`}
      style={{ width: size, height: size, ...style }}
      {...rest}
    >
      {children}
    </button>
  );
});

export default IconButton;
